module.exports = __webpack_public_path__ + "static/img/logo-scaled.750fa4b6.jpg";